import { render, staticRenderFns } from "./MagArticle.vue?vue&type=template&id=0cd2c3c4&scoped=true"
import script from "./MagArticle.vue?vue&type=script&lang=js"
export * from "./MagArticle.vue?vue&type=script&lang=js"
import style0 from "./MagArticle.vue?vue&type=style&index=0&id=0cd2c3c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd2c3c4",
  null
  
)

export default component.exports